export function updateToken(state, val) {
  state.token = val;
}

export function updateAddressInfo(state, val) {
  state.addressInfo = val;
}

export function updateUserInfo(state, val) {
  state.userInfo = val;
}

export function updateLoginParams(state, val) {
  state.loginParams = val;
}

export function updateOrderId(state, val) {
  state.orderId = val;
}

export function updateUserId(state, val) {
  state.userId = val;
}

export function updateToLoginPath(state, val) {
  state.toLoginPath = val;
}
export function updateAccessStatus(state, val = '') {
  state.accessStatus = val && val.toUpperCase();
}

export function updateStoreServes(state, val) {
  state.storeServes = val;
}

export function updateLanguage(state, val = 'id-ID') {
  state.language = val;
}

export function updateScheduled(state, val) {
  state.scheduled = val;
}

export function updateScheduledTime(state, val) {
  state.scheduledTime = val;
}

export function updateScheduledEndTime(state, val) {
  state.scheduledEndTime = val;
}
export function updateCountryCode(state, val) {
  state.countryCode = val || '+62';
}

export function updateCountryName(state, val) {
  state.countryName = val || '+62';
}

export function updateNearestStatus(state, val) {
  state.nearestStatus = val;
}

export function updateFullDineInTableData(state, val) {
  state.fullDineInTableData = val;
}

export function updatePlatVoucher(state, val) {
  state.platVoucher = val;
}
export function updateVoucherDialog(state, val) {
  state.showVoucherDialogList = val;
}

export function updateAccount(state, val) {
  state.account = val;
}


